import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SHARETHIS_SCRIPT_SRC =
  'https://platform-api.sharethis.com/js/sharethis.js#property=63edab8cb2f3620019abbcfe&product=powr-social-feed';

const upsertMeta = (selector, buildElement) => {
  let element = document.querySelector(selector);
  if (!element) {
    element = buildElement();
    document.head.appendChild(element);
  }
  return element;
};

const syncSeoShareUrl = (url) => {
  const canonical = upsertMeta('link[rel="canonical"]', () => {
    const link = document.createElement('link');
    link.rel = 'canonical';
    return link;
  });
  canonical.setAttribute('href', url);

  const ogUrl = upsertMeta('meta[property="og:url"]', () => {
    const meta = document.createElement('meta');
    meta.setAttribute('property', 'og:url');
    return meta;
  });
  ogUrl.setAttribute('content', url);

  const twitterUrl = upsertMeta('meta[name="twitter:url"]', () => {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'twitter:url');
    return meta;
  });
  twitterUrl.setAttribute('content', url);
};

const reloadShareThis = () => {
  document.querySelectorAll('script[src*="platform-api.sharethis.com/js/sharethis.js"]').forEach((node) => {
    node.remove();
  });

  document.querySelectorAll('[id^="st-"]').forEach((node) => {
    node.remove();
  });

  if (window.__sharethis__) {
    delete window.__sharethis__;
  }
  if (window.stWidget) {
    delete window.stWidget;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = SHARETHIS_SCRIPT_SRC;
  document.body.appendChild(script);
};

const TOOLS_PATH = /^\/tools(\/|$)/;
const COLLAPSE_WAIT_MS = 15000;
const COLLAPSE_SETTLE_MS = 3000;

// 悬浮分享条异步创建,且 ShareThis 初始化时会自行移除 st-hidden。
// 因此在创建后的短暂稳定期内持续保持折叠;用户一旦点击分享条,即停止干预,可自由展开。
const collapseWhenReady = () => {
  let classObserver = null;
  let settleTimer = null;

  const stopClassObserver = () => {
    if (classObserver) {
      classObserver.disconnect();
      classObserver = null;
    }
    window.clearTimeout(settleTimer);
  };

  const holdCollapsed = (widget) => {
    const ensure = () => {
      if (!widget.classList.contains('st-hidden')) {
        widget.classList.add('st-hidden');
      }
    };
    ensure();
    classObserver = new MutationObserver(ensure);
    classObserver.observe(widget, { attributes: true, attributeFilter: ['class'] });
    widget.addEventListener('click', stopClassObserver, { capture: true, once: true });
    settleTimer = window.setTimeout(stopClassObserver, COLLAPSE_SETTLE_MS);
  };

  const existing = document.getElementById('st-2');
  let bodyObserver = null;
  let waitTimer = null;

  if (existing) {
    holdCollapsed(existing);
  } else {
    bodyObserver = new MutationObserver(() => {
      const widget = document.getElementById('st-2');
      if (widget) {
        bodyObserver.disconnect();
        holdCollapsed(widget);
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    waitTimer = window.setTimeout(() => bodyObserver.disconnect(), COLLAPSE_WAIT_MS);
  }

  return () => {
    if (bodyObserver) {
      bodyObserver.disconnect();
    }
    window.clearTimeout(waitTimer);
    stopClassObserver();
  };
};

export const ShareThisSync = () => {
  const location = useLocation();

  useEffect(() => {
    const url = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
    syncSeoShareUrl(url);
    reloadShareThis();
    return TOOLS_PATH.test(location.pathname) ? collapseWhenReady() : undefined;
  }, [location.pathname, location.search, location.hash]);

  return null;
};
